import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createMemoActions } from './actions';
import { MemoActions, MemoState } from './types';

export const useMemoStore = create<MemoState & MemoActions>()(
    immer((set, get, store) => ({
        memos: [],
        loading: false,
        selectedMemo: null,
        loadingMemo: false,
        error: undefined,
        ...createMemoActions(set, get, store),
    })),
);
